import { FieldInputProps, useField } from 'formik'
import React from 'react'
import { CFieldProps } from '@velocity/shared'

type InputProps = FieldInputProps<string> & {
  label?: string | React.ReactNode
  required?: boolean
  disabled?: boolean
  type?: string
  placeholder?: string
}
export function SwitchToggleInput({ label, ...props }: InputProps) {
  return (
    <div>
      <div className='flex items-center'>
        <div className='flex-1'>
          {/* <Label label={label} name={props.name} required={props.required} /> */}
        </div>
        <label className='inline-flex items-center cursor-pointer'>
          <input
            type='checkbox'
            className='sr-only peer'
            {...props}
            checked={props.value as any}
          />
          <div
            className={`relative w-11 h-6 opacity-50 bg-primary rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:opacity-100`}
          ></div>
        </label>
      </div>
      {/* <Error touched={meta?.touched} error={meta?.error} /> */}
    </div>
  )
}

export function SwitchToggleInput2(props: CFieldProps) {
  const [field, , helpers] = useField(props.name)
  return (
    <SwitchToggle
      field={{
        ...field,
        onChange: (val: React.ChangeEvent<HTMLInputElement>) => {
          helpers.setValue(val.target.checked)
        }
      }}
    />
  )
}
export function SwitchToggle(props: {
  field: FieldInputProps<any>
  // onChange: (val: React.ChangeEvent<HTMLInputElement>) => void
}) {
  return (
    <label className='items-center cursor-pointer'>
      <input
        type='checkbox'
        className='sr-only peer'
        {...props.field}
        checked={props.field.value as any}
      />
      <div
        className={`relative w-11 h-6 opacity-50 bg-primary rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:opacity-100`}
      ></div>
    </label>
  )
}
